import { render, staticRenderFns } from "./allProduct.vue?vue&type=template&id=61d06a92&scoped=true"
import script from "./allProduct.vue?vue&type=script&lang=js"
export * from "./allProduct.vue?vue&type=script&lang=js"
import style0 from "./allProduct.vue?vue&type=style&index=0&id=61d06a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d06a92",
  null
  
)

export default component.exports